<template>
  <div
    v-if="showStageHighlight"
    class="container"
  />
</template>

<script setup lang="ts">
const { showStageHighlight } = useRuntimeConfig().public;
</script>

<style lang="scss" scoped>
.container {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 4px;

  background-color: rgb(var(--v-theme-red));

  z-index: 2000;
  pointer-events: none;
}
</style>
